import {
  CPKvKeys,
  useGetCPKeyPairValue,
} from 'api/content-platform/useAPIKeyValue'
import { useCompareAsesmenRefleksiPeriod } from '../utils'

import type { IAsesmenRefleksiPeriodData } from 'types/competency-profile'

export const useAsesmenRefleksiPeriod = (currentDateTimeServer: string) => {
  const { data, isSuccess } = useGetCPKeyPairValue<IAsesmenRefleksiPeriodData>(
    CPKvKeys.AsesmenRefleksiPeriod,
    true,
    {
      staleTime: 60 * 60 * 1000, // stale after 60 min, force to refetch upon mounting
    }
  )

  return useCompareAsesmenRefleksiPeriod(
    currentDateTimeServer,
    isSuccess && data.data
  )
}
